import classNames from 'classnames';
import React from 'react';
import { FaCheckCircle, FaRegCircle, FaSpinner, FaTimesCircle } from 'react-icons/fa';

import { RestaurantResponse } from '@/api/lib/restaurant';

const StepIcon = ({ status }: { status: string }) => {
  switch (status) {
    case 'complete':
      return <FaCheckCircle className="text-success min-w-5 min-h-5" />;
    case 'rejected':
      return <FaTimesCircle className="text-red-500 min-w-5 min-h-5" />;
    case 'in-progress':
      return <FaSpinner className="text-primary animate-spin ring-[1px] min-w-4 min-h-4 rounded-full p-0.5 ring-primary" />;
    case 'pending':
      return <FaRegCircle className="text-gray-400 min-w-5 min-h-5" />;
    default:
      return null;
  }
};

type Props = {
  restaurant: RestaurantResponse;
};

export const LoadingProcessAdapted = ({ restaurant }: Props): JSX.Element => {
  const steps = [
    { label: 'Inscription du restaurant', status: 'complete' },
    { label: 'Récupération de vos données sur Google Maps', status: 'complete' },
    {
      label: 'Analyse et modération par notre équipe',
      status: restaurant.validationStatus === 'REJECTED' ? 'rejected' : restaurant.validationStatus === 'PENDING' ? 'pending' : 'complete'
    },
    { label: 'Création de la fiche restaurant', status: restaurant.validationStatus === 'ACCEPTED' ? 'complete' : 'pending' },
    { label: "Publication de la fiche sur MonResto'Halal", status: restaurant.validationStatus === 'ACCEPTED' ? 'complete' : 'pending' }
  ];

  return (
    <ol className="gap-10 grid md:grid-cols-5 max-w-7xl mx-auto pt-12 px-5 md:px-0">
      {steps.map((step, index) => (
        <li key={index} className="w-full">
          <a className={classNames(step.status !== 'pending' ? 'border-primary' : 'border-gray-400', 'flex gap-3 border-solid font-medium pt-3 border-t-2')}>
            <div className="mt-1">
              <StepIcon status={step.status} />
            </div>
            <div>
              <span className={classNames(step.status !== 'pending' ? 'text-primary' : 'text-gray-600', 'text-md font-semibold')}>Étape {index + 1}</span>
              <h4 className={classNames(step.status === 'complete' ? 'text-gray-800' : 'text-gray-600', 'text-md')}>{step.label}</h4>
            </div>
          </a>
        </li>
      ))}
    </ol>
  );
};
